/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/to_timeduration.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Converts an input value into a `time_duration` value.
 *
 * @example
 * ROW x = "2024-01-01"::datetime
 * | EVAL y = x + "3 hours"::time_duration, z = x - TO_TIMEDURATION("3 hours");
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'to_timeduration',
  signatures: [
    {
      params: [
        {
          name: 'field',
          type: 'keyword',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
      ],
      variadic: false,
      returnType: 'time_duration',
    },
    {
      params: [
        {
          name: 'field',
          type: 'text',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
      ],
      variadic: false,
      returnType: 'time_duration',
    },
    {
      params: [
        {
          name: 'field',
          type: 'time_duration',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
      ],
      variadic: false,
      returnType: 'time_duration',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
